<template>
  <PageWrapper
    :active-page="PAGE_COMMUNITY_COMMUNITY"
    :active-section="SECTION_COMMUNITY"
    :breadcrumbs="breadcrumbs"
    align="left"
    page-name="Message"
    sub-title=""
    width="fixed"
  >
    <Chatroom
      :conversation-id="conversationId"
      :entity-id="orgId"
      :has-chat-room-header="false"
      context="direct_message"
    />
  </PageWrapper>
</template>

<script>
import PageWrapper from "@/components/PageWrapper.vue";
import { PAGE_COMMUNITY_COMMUNITY, SECTION_COMMUNITY } from "@/constants/nav-constants";
import Chatroom from "%/components/community/chatrooms/slack-style/Chatroom.vue";
import { useOrganizationStore } from "@/stores/organization-store";

export default {
  name: "OrgMessagePage",
  components: { Chatroom, PageWrapper },
  props: {
    orgId: {
      type: Number,
      required: true,
    },
    conversationId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      SECTION_COMMUNITY,
      PAGE_COMMUNITY_COMMUNITY,
      breadcrumbs: [
        { url: "/", label: "Home" },
        { url: "/community", label: "Community" },
        { url: `/community/org/${this.orgId}/profile`, label: useOrganizationStore().orgName },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>

</style>
